import React from "react";
import { puzzlePieceIcon } from "../common/IconLibrary";
import PinButton from "../common/PinButton";
import usePins from "../../hooks/usePins";

const FragmentCard = ({ item, onClick, height = null }) => {
  const { isPinned, togglePin, canPin } = usePins("fragments");
  return (
    <div
      className={`px-4 py-2 card-glass ${height ? "" : "h-full"}`}
      style={height ? { height } : {}}
      onClick={onClick}
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-start min-h-[50px]">
          <div className="flex-grow">
            <div className="relative group flex-grow">
              <h3 className="text-xl font-semibold text-gray-100 break-all overflow-hidden line-clamp-1 text-left">
                {item.name}
              </h3>
              <h3 className="hint-glass text-xl font-semibold text-gray-100 break-all text-right">
                {item.name}
              </h3>
            </div>
            <div className="flex justify-between">
              <div className="text-sm text-gray-400 text-right font-semibold">
                Version: {item.latest_version}
              </div>
              {item.imported && (
                <div className="text-sm text-red-400 text-left font-semibold">
                  Imported
                </div>
              )}
            </div>
          </div>
          <PinButton
            className="self-center flex-shrink-0"
            size={15}
            pinned={isPinned(item?.id)}
            disabled={!canPin}
            onToggle={() => togglePin(item?.id)}
          />
          <div className="text-3xl text-gray-300 ml-1 flex-shrink-0">
            <span
              dangerouslySetInnerHTML={{ __html: puzzlePieceIcon }}
              className="inline-block overflow-hidden"
              style={{
                height: "48px",
                width: "48px",
                display: "flex",
                alignItems: "center",
              }}
            />
          </div>
        </div>
        <div className="py-1">
          <hr className="py-1 border-t border-gray-600" />
        </div>
        <div className="relative group flex-grow break-words">
          <p className="text-gray-300 mb-4 line-clamp-5 overflow-hidden min-h-[50px] group-hover:invisible">
            {item.description}
          </p>
          <div className="hint-glass break-words line-clamp-5 overflow-y-auto dark-slim-scrollbar">
            {item.description}
          </div>
        </div>
        <div className="py-1">
          <hr className="py-1 border-t border-gray-600" />
        </div>
        <div className="flex justify-between items-start">
          <div className="text-sm text-gray-400 text-left">
            <div className="font-semibold text-gray-300">Created By</div>
            <div>{item.created_by}</div>
            <div>{new Date(item.created_at).toLocaleString()}</div>
          </div>
          <div className="text-sm text-gray-400 text-right">
            <div className="font-semibold text-gray-300">Updated By</div>
            <div>{item.updated_by}</div>
            <div>{new Date(item.updated_at).toLocaleString()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FragmentCard;
